export default {
    GroupSettings: {
        information: '集团信息',
        name: '集团全称',
        abbreviated: '集团简称',
        ps1: '支持PNG/JPG格式，且不超过500KB',
        ps2: '支持.ico格式，且不超过200KB',
        ps3: '请输入集团全称',
        ps4: '请输入集团简称',
        ps5: '长度在 1 到 60 个字符',
    }
};
